export const PLAN_BASED_MESSAGES = {
  free: {
    ADMIN:
      "Contact sharing is allowed for maximum 3 users in Free plan, please upgrade to share with more users.",
    USER:
      "Contact sharing is allowed for maximum 3 users in Free plan, please ask your admin to upgrade to share with more users.",
  },
};
